import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=3791db4f&"
import script from "./AccordionItem.vue?vue&type=script&lang=ts&"
export * from "./AccordionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports